import { TableConfiguration } from "../Models/TableConfiguration";

function toTableConfigurations(data){
    let config = [];
    for (let configuration of data){
        let modConfig = new TableConfiguration(configuration);
        config.push(modConfig);
    }
    config.sort((a,b) => (a.ConfigurationName < b.ConfigurationName) ? -1 : ((a.ConfigurationName > b.ConfigurationName) ? 1 : 0))
    return config;
}

export {toTableConfigurations};